/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import cs from "classnames";
import classes from "./CharacterSubmissionItem.module.scss";
import PropTypes from "prop-types";
import Modal from "../../../../organisms/Modal";
import CharactersModal from "../CharactersModal/CharactersModal";
import Icon, { NAMES, SIZES } from "../../../../atoms/Icon";
import { useModal } from "../../../../../hooks";
import { observer } from "mobx-react-lite";
import { formatChildNames } from "../../WritingCompetition";

const CharacterSubmissionItem = observer(({ character, bgColor, onCharacterClick }) => {
  const charactersFormModal = useModal();
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  console.log(character, 'character');

  const childNames = formatChildNames(character?.selected_childs);
  
  // Get writer photos array
  const writerPhotos = character?.character_submission?.data?.writer_photo || [];
  const hasMultiplePhotos = writerPhotos.length > 1;
  const currentPhoto = writerPhotos[currentPhotoIndex] || "";

  // Reset photo index when character changes
  useEffect(() => {
    setCurrentPhotoIndex(0);
  }, [character?.id]);

  const handlePreviousPhoto = (e) => {
    e.stopPropagation(); // Prevent triggering the modal
    setCurrentPhotoIndex((prev) => 
      prev === 0 ? writerPhotos.length - 1 : prev - 1
    );
  };

  const handleNextPhoto = (e) => {
    e.stopPropagation(); // Prevent triggering the modal
    setCurrentPhotoIndex((prev) => 
      prev === writerPhotos.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <>
      <div className={cs(classes.card)}>
        {/* Character Square with Photo Slider */}
        <div
          className={cs(classes.characterSquareContainer)}
          style={{
            border: `10px solid ${bgColor}`,
          }}
          onClick={() => {
            onCharacterClick(character);
            charactersFormModal.onOpen();
          }}
        >
          {currentPhoto && (
            <img
              className={cs(classes.characterSquare)}
              src={currentPhoto}
              alt="Writer"
            />
          )}
          
          {/* Navigation Arrows - Only show if multiple photos */}
          {hasMultiplePhotos && (
            <>
              <button
                className={cs(classes.sliderArrow, classes.sliderArrowLeft)}
                onClick={handlePreviousPhoto}
                aria-label="Previous photo"
              >
                <Icon name={NAMES.CHEVRON_LEFT} size={SIZES.L} />
              </button>
              <button
                className={cs(classes.sliderArrow, classes.sliderArrowRight)}
                onClick={handleNextPhoto}
                aria-label="Next photo"
              >
                <Icon name={NAMES.CHEVRON_RIGHT} size={SIZES.L} />
              </button>
              
              {/* Photo Indicator */}
              <div className={cs(classes.photoIndicator)}>
                {currentPhotoIndex + 1} / {writerPhotos.length}
              </div>
            </>
          )}
        </div>


        {/* Character Label */}
        <div
          onClick={() => {
            onCharacterClick(character);
            charactersFormModal.onOpen();
          }}
          className={cs(classes.characterLabel, classes.grandstanderFamily)}
          style={{ backgroundColor: bgColor }}
        >
          My Story
        </div>

        {/* Character Info */}
        <div className={cs(classes.characterInfo)}>
          <p className={cs(classes.characterName, classes.grandstanderFamily)}> {childNames || "Unnamed Character"}</p>
          <p className={cs(classes.characterLocation)}>
            {character?.location?.address && `${character.location.address} `}
          </p>
        </div>
      </div>

      <Modal opened={charactersFormModal.isOpened}>
        <div className={cs(classes.addCharacterModalConatiner)}>
          <div className={cs(classes.addCharacterModalCard)}>
            <CharactersModal />
            <div
              className={cs(classes.iconCross)}
              onClick={() => {
                charactersFormModal.onClose();
              }}
            >
              <Icon name={NAMES.X} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
});

CharacterSubmissionItem.propTypes = {
  character: PropTypes.shape({
    color: PropTypes.string.isRequired,
    names: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
  }),
  bgColor: PropTypes.string.isRequired, // Optional prop for background color
};

export default CharacterSubmissionItem;
